export default function getLocalizedText(textsByLocale, locale, textCode) {
  if (!textsByLocale || !textCode) return '';

  for (const l of [locale, 'en']) {
    const textsByCode = textsByLocale[l];
    if (!textsByCode) continue;

    const translationKey = Object.keys(textsByCode).find(
      k => k.toLocaleLowerCase() === textCode.toLocaleLowerCase()
    );

    if (translationKey) return textsByCode[translationKey];
  }

  return '';
}
